import React from "react";
import Skeleton from "react-loading-skeleton";
import {useSelector} from "react-redux";
import {useWindowWidth} from "../../../../hooks/useWindowWidth";
import {SkeletonWrapper} from "./SkeletonWrapper";

export const WidgetsSkeleton = () => {
    const {navPanelCollapsed} = useSelector(state => state.globalParams.globalParams);
    const width = useWindowWidth();
    const isWide = navPanelCollapsed ? width > 1300 : width > 1450;

    const columnLayout = {
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
    }

    const transparentStyle = {
        background: 'transparent',
        boxShadow: 'none'
    }

    const qrFrequencyExceptionStyle = navPanelCollapsed && width < 1450 ?
        {...transparentStyle, marginBottom: '24px'} :
        transparentStyle;

    return (
        <SkeletonWrapper>
            <div className={'statistics-widgets-layout'} style={!isWide ? columnLayout : {}}>
                <div className={'widgets-left-col'}>
                    <div className={'statistic-widget qr-code'} style={transparentStyle}>
                        <Skeleton height={240}/>
                    </div>
                    {isWide ?
                        <div className={'statistic-widget users'} style={transparentStyle}>
                            <Skeleton height={'100%'}/>
                        </div> :
                        <div className={'statistic-widget qr-frequency'} style={qrFrequencyExceptionStyle}>
                            <Skeleton height={'100%'}/>
                        </div>
                    }
                </div>
                <div className={'widgets-right-col'}>
                    {isWide ?
                        <div className={'statistic-widget qr-frequency'} style={qrFrequencyExceptionStyle}>
                            <Skeleton height={'100%'}/>
                        </div> :
                        <div className={'statistic-widget popular-dishes'}
                             style={transparentStyle}>
                            <Skeleton height={240}/>
                        </div>
                    }
                    {isWide ?
                        <div className={'statistic-widget popular-dishes'}
                             style={transparentStyle}>
                            <Skeleton height={240}/>
                        </div> :
                        <div className={'statistic-widget users'} style={transparentStyle}>
                            <Skeleton height={'100%'}/>
                        </div>
                    }
                </div>
            </div>
        </SkeletonWrapper>
    );
}